import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'company-sub-block-card',
  templateUrl: './company-sub-block-card.component.html',
  styleUrls: ['./company-sub-block-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySubBlockCardComponent {
  @Input() public subTitle: string;
  @Input() public subHint: string;
  @Input() public isShowRequired: boolean;
  @Input() public isShowOptional: boolean;
  @Input() public isShowFooter: boolean = false;
  @Input() public isMarginTop: boolean;
  @Input() public isMarginBottom: boolean;
}
